var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('v-btn',{staticClass:"ma-auto text-capitalize",attrs:{"icon":"","depressed":""},on:{"click":_vm.createContrat}},[_c('v-icon',{attrs:{"color":_vm.$colors[0]}},[_vm._v("mdi-text-box-edit")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }